import {
  Box,
  Button,
  Flex,
  HStack,
  TableContainer,
  useDisclosure,
  Text,
  Table,
  Th,
  Tbody,
  Tr,
  Td,
  VStack,
  Avatar,
  Icon,
  Spinner,
  Thead,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Center,
  Tabs,
  TabList,
  Tab,
  Select,
  ModalFooter,
  ModalHeader,
  ModalCloseButton,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import Header from '../../../components/header/Header';
import SearchBar from '../../../components/searchbar/SearchBar';
import moment from 'moment';
import { mutateFunction, useMutation } from '../../../libs/apis';
import { CustomToast } from '../../../components/toast/CustomToast';
import { useData } from '../../../data';
import IsDesktop from '../../../utils/IsDesktop';
import ViewUserDetails from './ViewUserDetails';
import CountSection from './CountSection';
import { BsDownload } from 'react-icons/bs';
import exportToCSV from '../../../utils/ExportToCSV';
import BrandButton from '../../../components/brandButton/BrandButton';
import { CheckIcon, CloseIcon } from '@chakra-ui/icons';
import { useSelector } from 'react-redux';
import PermissionBlinder from '../../../components/PermissionBlinder';

import { DatePicker, Space } from 'antd';
import dayjs from 'dayjs';

import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';
import { BASE_URL } from '../../../helpers/constant';
import client from '../../../libs/client';

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
const { RangePicker } = DatePicker;


const Deals = () => {
  const [displayedListStatus, setDisplayedListStatus] = useState('open');
  const [displayedList, setDisplayedList] = useState([]);
  const [openDeals, setOpenDeals] = useState([]);
  const [closedDeals, setClosedDeals] = useState([]);
  const [selecteduser, setSelectedUser] = useState();
  const { mutate, isLoading: isLoadingMutation } = useMutation(mutateFunction);
  const [tabIndex, setTabIndex] = useState(0);
  const [from, setFrom] = useState(
    moment().startOf('month').format('YYYY-MM-DD'),
  );
  const [diff, setDiff] = useState('week');

  const [to, setTo] = useState(moment().format('YYYY-MM-DD'));
  const [comparisonValue, setComparisonValue] = useState('month');

  const { data, isLoading, refetch } = useData(`admins/fetch-deals?from=${from}&to=${to}`);


  const { addToast } = CustomToast();
  const isDesktop = IsDesktop();
  const {
    isOpen,
    onClose,
    onToggle,
    onOpen
  } = useDisclosure()
  const {
    isOpen : deleteAdminIsOpen,
    onClose: onCloseDeleteAdmin,
    onToggle: onToggleDeleteAdmin
  } = useDisclosure()

  const onComparisonChange = (e) => {
    setComparisonValue(e.target.value);
  };

  const _permissions = useSelector(
    (state) => state?.user?.userInfo?.permissions,
  );

  useEffect(() => {
    if (comparisonValue === 'week') {
      setFrom(moment().startOf('week').format('YYYY-MM-DD'));
      setTo(moment().format('YYYY-MM-DD'));

    } else if (comparisonValue === 'month') {
      setFrom(moment().startOf('month').format('YYYY-MM-DD'));
      setTo(moment().format('YYYY-MM-DD'));
    } else if (comparisonValue === 'year') {
      setFrom(moment().startOf('year').format('YYYY-MM-DD'));
      setTo(moment().format('YYYY-MM-DD'));
    } else if (comparisonValue === 'all') {
      setFrom(
        moment().subtract(19, 'year').startOf('year').format('YYYY-MM-DD'),
      );
      setTo(moment().format('YYYY-MM-DD'));
    } else {
      onOpen();
    }
  }, [comparisonValue]);


  useEffect(() => {
    let _diff = moment(to).diff(from, 'day');
    if (_diff < 8) {
      setDiff('day');
    } else if (_diff < 80) {
      setDiff('week');
    } else if (_diff < 367) {
      setDiff('month');
    } else if (_diff < 730) {
      setDiff('quarter');
    } else {
      setDiff('year');
    }
    getData();
  }, [from, to]);

  const getData = () => {
    return client()
      .get(
        `${BASE_URL}admins/fetch-deals?from=${from}&to=${to}`,
      )
      .then((res) => {
        const data = res?.data || {};
        if (data?.data) {    
          setOpenDeals(data?.data?.openDeals);
          setClosedDeals(data?.data?.closedDeals);
        }
      });
  };


  const onCalendarChange = (date) => {
    let dates = date.map((value) =>
      moment(value?.$d ? value['$d'] : moment()).format('YYYY-MM-DD'),
    );
    let _from = moment(dates[0]).isAfter(moment().subtract(1, 'day'))
      ? moment().subtract(1, 'day').format('YYYY-MM-DD')
      : moment(dates[0]).format('YYYY-MM-DD');
    let _to = moment(dates[1]).isAfter(moment())
      ? moment().format('YYYY-MM-DD')
      : moment(dates[1]).format('YYYY-MM-DD');
    setFrom(_from);
    setTo(_to);
    let _diff = moment(to).diff(from, 'day');
  };

  const changeUserView = (advertStatus) => {
    setDisplayedListStatus(advertStatus);
  };
  const viewUser = (user) => {
    setSelectedUser(user);
    onToggle()
    // onToggleUserDetails();
  };

  const handleTabsChange = (index) => {
    setTabIndex(index);
  };
  useEffect(() => {
    if (data?.data) {
      setOpenDeals(data?.data?.openDeals);
      setClosedDeals(data?.data?.closedDeals);
    }
  }, [data, refetch]);

  

  const onSubmitSuccess = () => {
    onClose()
    refetch()
    setSelectedUser(null)
  }

  const deleteAdmin = async (e) => {
    try {
        e.preventDefault()
        if(isLoading || isLoadingMutation) return
        const url = `subadmins/${selecteduser.user_id}`;
        const method = 'DELETE'
        mutate(
            {
                key: url,
                method,
                data: {},
            },
            {
              onSuccess(res) {
                  addToast(res);
                  refetch()
                  onCloseDeleteAdmin()
                  setSelectedUser(null)
              },
              onError(e) {
                  addToast({ message: `Sub admin was not deleted, ${e || ''}` }, 'error');
              },
            },
        );
    } catch (err) {
        console.error(err);
        addToast({ message: `Could not delete sub admin` }, 'error');
    }
  };

  if(_permissions && !_permissions?.can_manage_deals){
    return <PermissionBlinder />
  }

  return (
    <>
      <Box>
        <Header title="Deals" />
        {/* {isOpen && (
          <ViewUserDetails user={selecteduser} onToggle={onToggleUserDetails} />
        )} */}
        {true && (
          <>
            <Flex w="100%">
              <Box mt="20px" w="100%">
                <Box
                  w="100%"
                  className="items-center flex flex-wrap gap-2 px-3 max-w-screen-2xl"
                >
                  <CountSection
                    count={openDeals.length + closedDeals.length}
                    title={"Total Deals"}
                  />
                  <CountSection
                    count={openDeals.length}
                    title={"Open Deals"}
                  />
                  <CountSection
                    count={closedDeals.length}
                    title={"Closed Deals"}
                  />
                </Box>
              </Box>
            </Flex>
            <Box className='p-5 flex gap-3 max-w-screen-2xl'>
                  <Tabs
                    className="w-fit"
                    index={tabIndex}
                    onChange={handleTabsChange}
                  >
                  <TabList>
                    <Tab>Open Deals</Tab>
                    <Tab>Closed Deals</Tab>
                  </TabList>
                </Tabs>
                <Flex className="flex-row gap-8 flex-wrap items-center">
                  <Flex className="max-w-xl">
                      <Select
                        value={comparisonValue}
                        onChange={onComparisonChange}
                        placeholder=""
                      >
                        <option value="week">This Week</option>
                        <option value="month">This Month</option>
                        <option value="year">This Year</option>
                        <option value="all">All Time</option>
                        <option value="custom">Custom</option>
                      </Select>
                    </Flex>
                    {comparisonValue === 'custom' && (
                      <Button colorScheme="blue" onClick={onOpen}>
                        Change custom selection
                      </Button>
                    )}
                </Flex>
            </Box>
            <Box
              className={`flex-col w-full overflow-x-auto hide-scroll ${
                isDesktop
                  ? 'max-h-[75vh] fixed px-2 pb-32 overflow-y-scroll'
                  : ''
              }`}
            >
              <Box overflowX="auto">
              <TableContainer
                mt="10px"
                borderRadius="10px"
                overflowX="auto"
                className='w-[80%] xl:w-[85%] hide-scroll'
              >
                <Table
                  variant="simple"
                  size="sm"
                  fontSize="12px"
                  w={['100%']}
                  minWidth="900px"
                >
                  <Thead>
                    <Tr>
                      <Th>Deal Name</Th>
                      <Th>Company</Th>
                      <Th>User</Th>
                      <Th>Status</Th>
                      <Th>Funding Round</Th>
                      <Th>Deal Stage</Th>
                      <Th>Target Amount</Th>
                      <Th>Public Deal</Th>
                    </Tr>
                  </Thead>
                  {!isLoading ? (
                    <Tbody>
                    {tabIndex == 0 && openDeals.map((item) => (
                      <Tr className={`cursor-pointer`} key={item.id}>
                        <Td>{item.name}</Td>
                        <Td>{item.company?.title}</Td>
                        <Td>{`${item.user?.first_name} ${item.user?.last_name}`}</Td>
                        <Td className='capitalize'>{item.status.replace('_', ' ')}</Td>
                        <Td>{item.stage}</Td>
                        <Td className='capitalize'>{item.stage_of_interaction.replace('_', ' ')}</Td>
                        <Td>{item?.target_amount || 'Not Specified'}</Td>
                        <Td>{item?.is_public ? 'Yes' : 'No'}</Td>
                      </Tr>
                    ))}
                    {tabIndex == 1 && closedDeals.map((item) => (
                      <Tr className={`cursor-pointer`} key={item.id}>
                        <Td>{item.name}</Td>
                        <Td>{item.company?.title}</Td>
                        <Td>{`${item.user?.first_name} ${item.user?.last_name}`}</Td>
                        <Td className='capitalize'>{item.status.replace('_', ' ')}</Td>
                        <Td>{item.stage}</Td>
                        <Td className='capitalize'>{item.stage_of_interaction.replace('_', ' ')}</Td>
                        <Td>{item?.target_amount || 'Not Specified'}</Td>
                        <Td>{item?.is_public ? 'Yes' : 'No'}</Td>
                      </Tr>
                    ))}
                  </Tbody>
                  ) : (
                    <Spinner m={5} />
                  )}
                </Table>
              </TableContainer>
              </Box>
            </Box>
          </>
        )}
        <>
          <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>Select Custom Range</ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                <Flex className="mb-5 flex-col gap-5 items-center">
                  <Flex className="w-full items-start flex-col gap-2">
                    <Text>
                      Current Date Range: {from} to {to}
                    </Text>
                    <Text className="text-xs italic">
                      N/B: Date format is YYYY-MM-DD
                    </Text>
                  </Flex>
                  <RangePicker
                    value={[dayjs(from), dayjs(to)]}
                    maxDate={dayjs()}
                    onCalendarChange={onCalendarChange}
                    format="YYYY-MM-DD"
                  />
                  <ModalFooter>
                    <Button onClick={onClose} colorScheme="blue">
                      See Results
                    </Button>
                  </ModalFooter>
                </Flex>
              </ModalBody>
            </ModalContent>
          </Modal>
        </>
      </Box>
    </>
  );
};

export default Deals;
